<template>
  <div id="Content">
    <section class="figer-wrapper   pb-5 mt-5 bgfff"  >
        <div class="title mb-5 container text-center title-hr">
            <h3>什么是科技型中小企业</h3>
            <h4 class="text-1e6ce8 ">Technology-based enterprise</h4>
        </div>
        <div class=" ">
            <div class="container">
                <div class="row  ">
                    <div class="col-md-12 col-12  text-333 text-center clearfix">
                      <p>科技型中小企业是指以依托一定数量的科技人员,从事科学技术研究开发活动，取得自主知识产权并将其转化为高新技术产品或服务，从而实现可持续发展的中小企业。</p>
                    </div>
                    <p class="text-center col-md-12 col-xs-12 pt-5 ">
                        <a class="btn-custom" href="http://pkt.zoosnet.net/LR/Chatpre.aspx?id=PKT58642380&lng=cn" rel='nofollow' target="_blank">
                            了解更多+
                        </a>
                    </p>
                    <div class="col-md-12 col-xs-12 text-center">
                      <a  href="http://pkt.zoosnet.net/LR/Chatpre.aspx?id=PKT58642380&lng=cn" rel='nofollow' target="_blank">
                        <img :src="activeImg[0].img" style="margin:30px auto 0">
                      </a>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section class="figer-wrapper   pb-5 mt-5  bgf8f6f9"  >
        <div class="title mb-5 container text-center title-hr">
            <h3>成为科技型中小企业的<span class="text-1e6ce8 font-bold">10</span>大好处!</h3>
            <h4 class="text-1e6ce8 ">Ten big benefits</h4>
        </div>
        <div class="container">
            <div class="in-register-main clearfix zcdz-main kjxzxqy row">
                <div class="col-md-6 col-xs-6 li">
                    <div class="item bg-fff">
                        <div class="row">
                            <div class="col-md-5 col-xs-5 left">
                                <img :src="activeImg[1].img" >
                            </div>
                            <div class="col-md-7 col-xs-7 ">
                                <div class="right">
                                    <h5>税收减免</h5>
                                    <p>
                                        研发费用按100%加计扣除；形成无形资产的，按无形资产成本的200%在税前摊销
                                    </p>

                                    <a v-b-modal.modal-1>
                                        更多详情&gt;
                                    </a>
                                </div>
                            </div>
                        </div>
                        <!-- Modal -->
                        <b-modal id="modal-1" hide-footer>
                            <div class="modal-body">
                                *财政部 税务总局 科技部公告2022年第16号公告
                            </div>
                        </b-modal>
                    </div>
                </div>
                <div class="col-md-6 col-xs-6 li">
                    <div class="item bg-fff">
                        <div class="row">
                            <div class="col-md-5 col-xs-5 left">
                                <img :src="activeImg[2].img" class="">
                            </div>
                            <div class="col-md-7 col-xs-7 ">
                                <div class="right">
                                    <h5>官媒背书，登报公示资质</h5>
                                    <p>
                                        具大大提升企业形象，提高品牌影响力和宣传度
                                    </p>
                                    <a v-b-modal.modal-2>
                                        更多详情&gt;
                                    </a>
                                </div>
                            </div>
                        </div>
                         <!-- Modal -->
                        <b-modal id="modal-2" hide-footer>
                            <div class="modal-body">
                                *《财政部 税务总局关于延长高新技术企业和科技型中小企业亏损结转年限的通知》（财务〔2018〕76号）
                            </div>
                        </b-modal>
                        <!-- Modal -->
                    </div>
                </div>
                <div class="col-md-6 col-xs-6 li">
                    <div class="item bg-fff">
                        <div class="row">
                            <div class="col-md-5 col-xs-5 left">
                                <img :src="activeImg[3].img" class="left">
                            </div>
                            <div class="col-md-7 col-xs-7 ">
                                <div class="right">
                                    <h5>中国科技部授予资质备案</h5>
                                    <p>
                                        附有专属入库编号---是企业创新能力“认证”标志。于企查查，天眼查等公示平台皆附专属标签可查，含金量十足。区别于其他民间协会颁发的各类资质证书。
                                    </p>

                                    <a v-b-modal.modal-3>
                                        更多详情&gt;
                                    </a>
                                </div>
                            </div>
                        </div>
                        <!-- Modal -->
                        <b-modal id="modal-3" hide-footer>
                            <div class="modal-body">
                                <img :src="activeImg[31].img" style="width:480px" >
                            </div>
                        </b-modal>
                    </div>

                </div>
                <div class="col-md-6 col-xs-6 li">
                    <div class="item bg-fff">
                        <div class="row">
                            <div class="col-md-5 col-xs-5 left">
                                <img :src="activeImg[4].img" class="left" >
                            </div>
                            <div class="col-md-7 col-xs-7 ">
                                <div class="right">
                                    <h5>亏损结转年限延长至10年</h5>
                                    <p>
                                        具备“科小”资格年度之前5个年度发生的尚未弥补完的亏损，准予结转以后年度弥补，最长结转年限由5年延长至10年。
                                    </p>
                                    <a v-b-modal.modal-4>
                                        更多详情&gt;
                                    </a>
                                </div>
                            </div>
                        </div>
                        <!-- Modal -->
                        <b-modal id="modal-4" hide-footer>
                            <div class="modal-body">
                                <img :src="activeImg[32].img" style="width:480px" >
                            </div>
                        </b-modal>
                    </div>

                </div>
                <div class="col-md-6 col-xs-6 li">
                    <div class="item bg-fff">
                        <div class="row">
                            <div class="col-md-5 col-xs-5 left">
                                <img :src="activeImg[5].img" class="left">
                            </div>
                            <div class="col-md-7 col-xs-7 ">
                                <div class="right">
                                    <h5>可申请50万元“创新券”财政补助</h5>
                                    <p>
                                        是一种财政补助方式，上限提高至50万元，以电子券形式发放，鼓励本市企业和团队向服务机构购买战略规划、技术研发、技术转移、检验检测、人才培养、资源开放等专业服务。
                                    </p>

                                     <a v-b-modal.modal-5>
                                        更多详情&gt;
                                    </a>
                                </div>
                            </div>
                        </div>
                        <!-- Modal -->
                        <b-modal id="modal-5" hide-footer>
                            <div class="modal-body">
                               <p class="font-16 font-bold">【申报条件】</p>
                                <p> 1.企业应在本市注册，具有独立的企业法人资格，财务和管理制度健全，且为非上市企业。</p>
                                <p> 2.企业主要从事高新技术产品的研究、开发、生产或服务等业务，具有创新能力和高成长潜力，一般无知识产权纠纷。</p>
                                <p> 3.企业上年度营业收入不超过3000万元，已完成的研发费用总额不低于50万元，且研发费用占营业收入比例不低于5%；职工总数不超过300人，其中直接从事研究开发的科技人员占比不低于10%。</p>
                                <p> 4.申报上年度及当年内未发生重大安全、重大质量事故和严重环境违法、科研严重失信行为，且未列入经营异常名录和严重违法失信企业名单。</p>
                                <p> 5.企业申报时根据科技型中小企业评价指标进行综合评价所得分值不低于60分，且科技人员指标得分不得为0分。</p>
                                <p> 6.同一企业获得创新资金资助的次数未满3次.</p>
                                <p class="font-16 font-bold">【支持方式】</p>
                                <p>采取后补的方式。对本辖区立项项目予以配套资助，且每个项目的资助额度不低于市拨付B档项目的经费额度。</p>
                                <p class="font-16 font-bold">【申报要求】</p>
                                <p> 除满足前述相应条件外，还须符合以下要求：</p>
                                <p> 1.项目申报单位在同一年度内只能申请一个创新资金项目，具有组织项目实施的相应能力。</p>
                                <p> 2.研究内容已经获得财政资金支持的，不得重复申报。</p>
                                <p> 3.所有申报单位和项目参与人应符合科研诚信管理要求。项目责任人应承诺所提交材料真实性，申报单位应当对申请人的申请资格负责，并对申请材料的真实性和完整性进行审核，不得提交有涉密内容的项目申请。</p>
                                <p> 4.申报项目若提出回避专家申请的，须在提交项目可行性方案的同时，上传由申报单位出具公函提出回避专家名单与理由。</p>
                                <p> 5.区科技行政部门对所辖区内的申报项目进行审核，并择优推荐。</p>
                            </div>
                        </b-modal>
                    </div>

                </div>
                <div class="col-md-6 col-xs-6 li">
                    <div class="item bg-fff">
                        <div class="row">
                            <div class="col-md-5 col-xs-5 left">
                                <img :src="activeImg[6].img" class="">
                            </div>
                            <div class="col-md-7 col-xs-7 ">
                                <div class="right">
                                    <h5>吸引资本逐鹿，更易招募并留住人才</h5>
                                    <p>
                                        科技型中小企业更有利于企业招募留住人才和吸引资本追逐。
                                    </p>

                                     <a v-b-modal.modal-6>
                                        更多详情&gt;
                                    </a>
                                </div>
                            </div>
                        </div>
                        <!-- Modal -->
                         <b-modal id="modal-6" hide-footer>
                            <div class="modal-body">
                                <p>近日,上海市科技创业中心、上海市大学生科技创业基金会与全市5家试点银行合力推出“科创助力贷”。这一贷款产品为科技型小微企业度身定制，利率低、无需担保费，最高额度300万元，将助力一大批企业研发具有自主知识产权及核心竞争力的产品。</p>
                                <p>为持续优化科技金融生态，进一步引导商业银行助力创新创业发展，市科委、市金融监管局、中国银行保险监督管委会上海监管局今年9月发布了《关于试点科创助力贷工作的通知》。试点对象是按照科技部、财政部、国家税务总局《科技型中小企业评价办法》、科技部火炬高技术产业开发中心《科技型中小企业评价办法工作指引（试行）》等文件规定，当年度通过科技型中小企业评价且上年度纳税申报销售收入不高于5000万元的本市小微企业。试点工作优先支持产品具有自主知识产权和核心竞争力的科技型小微企业、上海市大学生科技创业基金会“天使基金”已资助的科技型企业。</p>
                                <p>“科创助力贷”单笔贷款控制在50万元至300万元，贷款利率最高不超过4.5%，贷款期限为12个月以内。银行贷款产生的风险损失，由上海市科技创业中心和上海市大学生科技创业基金会按照一定比例提供补偿。企业可登录“一网通办”或上海市科技金融信息服务平台申请。</p>
                                <p>在合作单位前期调研和商讨的基础上，这一贷款产品推出后不到3个工作日，上海开先软件有限公司和上海山诺制冷电气设备工程有限公司就通过了上海农商银行的审批，上海市科技创业中心和上海市大学生科技创业基金会也仅用3个工作日，就为两家企业出具了首份“01号”推荐函。上海开先软件有限公司从事跨境支付系统的开发和安装，由于现场工程受疫情影响较大，经过一年多的探索，这家企业凭借前期积累的市场和牌照，开始向系统SaaS（软件即服务）服务商转型，但急缺运营资金。“得到这笔贷款后，我们可以进一步完善基础设施，提升企业的市场竞争力。”开先软件公司负责人说。</p>
                                <p>上海市科技创业中心介绍，为了满足企业贷款急的需求，“科创助力贷”优化了审核流程，银行审核后，创业中心仅作备案管理推荐。相较于传统的科技信贷产品，企业获贷时间减少了7至10个工作日，可解燃眉之急</p>
                                <p>
                                    据悉，上海近年来不断完善“3+X”科技信贷体系，满足不同发展阶段的科技型企业融资需求。“3”指的是“科技小巨人信用贷”“科技履约贷”和“科技微贷通”，“X”指“高企贷”“创投贷”“科技成果转化贷”等个性化产品。今年1—11月，“3+X”科技信贷体系累计完成57.40亿元，718家企业受益。随着“科创助力贷”的推出，这个信贷体系将得到进一步完善，扶持更多的科技型小微企业加速成长。（记者 俞陶然）
                                </p>
                            </div>
                        </b-modal>
                    </div>

                </div>
                <div class="col-md-6 col-xs-6 li">
                    <div class="item bg-fff">
                        <div class="row">
                            <div class="col-md-5 col-xs-5 left">
                                <img :src="activeImg[7].img" class="left">
                            </div>
                            <div class="col-md-7 col-xs-7 ">
                                <div class="right">
                                    <h5>申请创新资金补助</h5>
                                    <p>
                                        科小认证是申报科技型中小企业技术创新资金项目评审的必要条件。后续可对接创新创业大赛，可申请不超过 20万元/项创新资金补助。其中A档给予不超过20万元/项的资助；B档给予不超过10万元/项的资助
                                    </p>

                                    <a href="http://pkt.zoosnet.net/LR/Chatpre.aspx?id=PKT58642380&lng=cn" rel='nofollow' target="_blank">
                                        更多详情&gt;
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                <div class="col-md-6 col-xs-6 li">
                    <div class="item bg-fff">
                        <div class="row">
                            <div class="col-md-5 col-xs-5 left">
                                <img :src="activeImg[8].img" class="left">
                            </div>
                            <div class="col-md-7 col-xs-7 ">
                                <div class="right">
                                    <h5>企业招投标加分项及提高项目申报成功率</h5>
                                    <p>
                                        科技型中小企业将为企业产品招投标加分，并提高科技项目申报、研发机构建立等方面的成功率。
                                    </p>
                                    <a href="http://pkt.zoosnet.net/LR/Chatpre.aspx?id=PKT58642380&lng=cn" rel='nofollow' target="_blank">
                                        更多详情&gt;
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 col-xs-6 li">
                    <div class="item bg-fff">
                        <div class="row">
                            <div class="col-md-5 col-xs-5 left">
                                <img :src="activeImg[9].img" class="left">
                            </div>
                            <div class="col-md-7 col-xs-7 ">
                                <div class="right">
                                    <h5>利率低于 4.5%专项贷款</h5>
                                    <p>
                                        上海可申请“科创助力贷”，科技型小微企业最高可获300万贷款---“科创助力贷”单笔贷款控制在50万元至300万元，贷款利率最高不超过4.5%，贷款期限为12个月以内。银行贷款产生的风险损失，由上海市科技创业中心和上海市大学生科技创业基金会按照一定比例提供补偿。企业可登录“一网通办”或上海市科技金融信息服务平台申请。
                                    </p>

                                    <a href="http://pkt.zoosnet.net/LR/Chatpre.aspx?id=PKT58642380&lng=cn" rel='nofollow' target="_blank">
                                        更多详情&gt;
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                <div class="col-md-6 col-xs-6 li">
                    <div class="item bg-fff">
                        <div class="row">
                            <div class="col-md-5 col-xs-5 left">
                                <img :src="activeImg[10].img" class="">
                            </div>
                            <div class="col-md-7 col-xs-7 ">
                                <div class="right">
                                    <h5>成功率极高</h5>
                                    <p>
                                        科小认定目前正值窗口期，只要在行业类别内，每家企业都有机会认定成功。较高企认定而言，科小申请周期短成本低，科研成果转化门槛低，目前配合我们研发专账的财务服务，能保证总分达标，认定成功率极高。
                                    </p>

                                    <a v-b-modal.modal-9>
                                        更多详情&gt;
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <b-modal id="modal-9" hide-footer>
                        <div class="modal-body">
                            <p>科小认定目前正值窗口期，只要在行业类别内，每家企业都有机会认定成功。较高企认定而言，科小申请周期短成本低，科研成果转化门槛低，目前配合我们研发专账的财务服务，能保证总分达标，认定成功率极高。未来科小认定会逐步收紧加大门槛，因此越早申请越有利，也越快能享受相关政策。另外，科小作为准高企后备军，评价工作与高新技术企业培育、科技企业孵化器绩效评价、国家及省创业大赛等工作协同，可为后续高企认定布局做铺垫。</p>

                        </div>
                    </b-modal>
                </div>
                <p class="text-center col-md-12 col-xs-12 pt-5 ">
                    <a class="btn-custom" href="http://pkt.zoosnet.net/LR/Chatpre.aspx?id=PKT58642380&lng=cn" rel='nofollow' target="_blank">
                        了解更多+
                    </a>
                </p>

            </div>
        </div>
    </section>
    <section class="figer-wrapper  pb-5 mt-5 bgfff">
        <div class="container">
            <div class="row">
                <div class="col-md-12 col-xs-12 in-environment-main kjds-production">
                    <img :src="activeImg[11].img" alt="办公环境" id="F2018_23" style=" padding: 0 20px; ">
                </div>
            </div>
        </div>
    </section>
    <section class="figer-wrapper  in-zc-from-mb bgfff" >
        <div class="container ">
            <form class="form-inline row in-zc-from-content">
                <div class="form-group col-md-6 col-xs-6">
                    <div class="input-group col-md-12 col-xs-12 inline">
                        <input type="text" class="form-control" id="inputCompany"  v-model="company" placeholder="公司名称 如：企汇">
                    </div>
                </div>
                <div class="form-group col-md-4 col-xs-4" style="padding-left:0">
                    <div class="input-group col-md-12 col-xs-12 inline">
                        <input type="text" class="form-control" id="inputTelephone" v-model="telephone" placeholder="联系电话">
                    </div>

                </div>

                <button type="button" class="btn btn-primary col-md-2 col-xs-2 zc-btn-kjxzxqy" @click="submitForm($event)">立即申请</button>
            </form>
        </div>

    </section>
    <section class="figer-wrapper mb-5 mt-5 pb-5 in-nxqykukjzxqy-main">
        <div class="container">
            <div class="row list">
                <div class="col-md-7 col-xs-8 ">
                    <div class="col-md-12 col-xs-12 text-center  tilte-head">
                        <div class="title mb-5 container text-left title-hr  mt-5 ">
                            <h3>哪些企业可以申请入库科技型中小企业？</h3>
                            <h4 class="text-1e6ce8 ">What enterprise can apply for</h4>
                        </div>
                    </div>
                    <div class="col-md-12 col-xs-12 JWTS-p-5 list">
                        <div class="item"><div class="num">01</div><div class="right">中国境内（不含港、澳、台）注册的居民企业</div></div>
                        <div class="item"><div class="num">02</div><div class="right">职工人数不超过500人、年销售收入不超过2亿元</div></div>
                        <div class="item"><div class="num">03</div><div class="right">企业提供的产品和服务不属于国家规定的禁止、限制和淘汰类。</div></div>
                        <div class="item">
                            <div class="num">04</div>
                            <div class="right">
                                <div>企业申报的上一年及当年内，未发生重大安全、事故和严重失信行为，</div>
                                <div>且企业未列入经营异常名录和严重违法失信企业名单。</div>
                            </div>
                        </div>
                        <div class="item">
                            <div class="num">05</div>
                            <div class="right">
                                三项指标综合评价分值不低于60分
                                <ul>
                                    <li> 科技人员指标（人员指标），必须项，本项不得为0分</li>
                                    <li> 研发投入指标（财务指标），必须项，我们提供研发专账辅导确保达标。</li>
                                    <li> 科技成果指标（知产指标），本项没有可不提供，若有可加分。</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-5 col-xs-4 ">
                </div>
            </div>
        </div>
    </section>
    <section class=" in-choose bg-fff pb-5 mt-5 ">
        <div class="container">
            <div class="row">
                <div class="col-md-12 col-xs-12 ">
                    <div class="title mb-5 container text-center title-hr">
                        <h3>申请所需材料清单</h3>
                        <h4 class="text-1e6ce8 ">The required material</h4>
                    </div>
                </div>
                <div class="col-md-12 col-xs-12">
                    <div class="clearfix  step-center ">
                        <div class="row  in-choose-step">
                            <div class=" list">
                                <div class="item">
                                    <img :src="activeImg[12].img">
                                    <p class="mt-4 mt-md-5 font-16 font-bold">营业执照复印件</p>
                                </div>

                            </div>
                            <div class=" list">
                                <div class="item">
                                    <img :src="activeImg[13].img">
                                    <p class="mt-4 mt-md-5  font-16 font-bold">法人身份证扫描件</p>
                                </div>

                            </div>
                            <div class=" list">
                                <div class="item">
                                    <img :src="activeImg[14].img">
                                    <p class="mt-4 mt-md-5  font-16 font-bold">上一财年财务报表</p>
                                </div>

                            </div>

                            <div class=" list">
                                <div class="item">
                                    <img :src="activeImg[15].img">
                                    <p class="mt-4 mt-md-5  font-16 font-bold">填写信息采集表</p>
                                </div>

                            </div>
                            <div class=" list">
                                <div class="item">
                                    <img :src="activeImg[16].img">
                                    <p class="mt-4 mt-md-5  font-16 font-bold">系统盖章文件及收件信息</p>
                                </div>

                            </div>
                            <div class=" list">
                                <div class="item">
                                    <img :src="activeImg[17].img">
                                    <p class="mt-4 mt-md-5  font-16 font-bold">知识产权证书</p>
                                </div>

                            </div>

                        </div>
                    </div>

                </div>
               <p class="text-center col-md-12 col-xs-12 pt-5 ">
                    <a class="btn-custom" href="http://pkt.zoosnet.net/LR/Chatpre.aspx?id=PKT58642380&lng=cn" rel='nofollow' target="_blank">
                        了解更多+
                    </a>
                </p>
            </div>
        </div>

    </section>
    <!-- 申请流程及时间-->
    <section class="figer-wrapper   pb-5 mt-5  bgf8f6f9">
        <div class="container">
            <div class="row">
                <div class="title mb-5 container text-center title-hr">
                    <h3>申报流程及时间</h3>
                    <h4 class="text-1e6ce8 ">Process and time</h4>
                </div>
                <div class="col-md-12 col-xs-12">
                    <div class="in-choose-list">
                        <div class="item">
                                <img :src="activeImg[18].img">
                            <p class="title font-16 font-bold">准备材料</p>
                        </div>
                        <div class="item">
                            <img :src="activeImg[19].img">
                            <p class="title  font-16 font-bold">辅导达标</p>
                        </div>
                        <div class="item">
                                <img :src="activeImg[20].img">
                            <p class="title font-16 font-bold">材料填报</p>
                        </div>
                        <div class="item">
                                <img :src="activeImg[21].img">
                            <p class="title font-16 font-bold">市局审核</p>
                        </div>
                        <div class="item">
                                <img :src="activeImg[22].img">
                            <p class="title font-16 font-bold">科技部审核</p>
                        </div>
                        <div class="item">
                                <img :src="activeImg[23].img">
                            <p class="title font-16 font-bold">系统公示</p>
                        </div>
                        <div class="item">
                                <img :src="activeImg[24].img">
                            <p class="title font-16 font-bold">公告入库</p>
                        </div>
                    </div>
                </div>
                <div class=" col-md-12 col-sm-12 col-xs-12 text-center mb-10">
                    <p class="font-16 text-ff910b font-bold">所需时间：在指标达到要求，符合申请条件的情况下，目前申请科技型中小企业入库需20-45个工作日左右。</p>
                </div>
            </div>
        </div>

    </section>
    <!-- 入库科技型中小企业流程 -->
    <section class="figer-wrapper   pb-5 mt-5 ">
        <div class="container">
            <div class="row">
                <div class="col-md-12 col-xs-12 ">
                   <div class="title mb-5 container text-center title-hr">
                        <h3>入库科技型中小企业业务流程</h3>
                        <h4 class="text-1e6ce8 ">The Bussiness process</h4>
                    </div>
                </div>
                <div class="col-md-12 col-xs-12" >
                    <div class="row ">
                        <img :src="activeImg[25].img" class="img-responsive">
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- 服务内容-->
    <section class="figer-wrapper   pb-5 mt-5 bgf8f6f9 ">
        <div class="container">
            <div class="row">
                <div class="col-md-12 col-xs-12">
                   <div class="title mb-5 container text-center title-hr">
                        <h3>服务内容</h3>
                        <h4 class="text-1e6ce8 ">The Service content</h4>
                    </div>
                </div>
                <div class=" col-md-12 col-sm-12 col-xs-12 ">
                    <div class="in-fwnr-main">
                        <div class="item">
                            <div class="left"><i class="iconfont iconfudaoyuangang"></i></div>
                            <div class="right">
                                <h4 class="font-bold">全流程申报托管</h4>
                                <p>您只需提供资料，其余事项放心托管给我们进行全流程申报</p>
                            </div>
                        </div>
                        <div class=" item">
                            <div class="left"><i class="iconfont iconcaishuifuwu"></i></div>
                            <div class="right">
                                <h4 class="font-bold">专账辅导助力达标</h4>
                                <p>我们的服务包含1年期的研发专账财务指标辅导，我们对结果负责，助力企业达标</p>
                            </div>
                        </div>
                        <div class=" item">
                            <div class="left"><i class="iconfont iconjinqian"></i></div>
                            <div class="right">
                                <h4 class="font-bold">协助20万元奖补申请</h4>
                                <p>科小入库申请成功后，我们可协助申请创新资金补助，最高20万元</p>
                            </div>
                        </div>
                        <div class="item ">
                            <div class="left"><i class="iconfont iconhetong1"></i></div>
                            <div class="right">
                                <h4 class="font-bold">次年复评协助</h4>
                                <p>协助处理次年复评相关事项</p>
                            </div>
                        </div>
                        <div class="item ">
                            <div class="left"><i class="iconfont icondianhuazixun"></i></div>
                            <div class="right">
                                <h4 class="font-bold">高企政策微咨询协助</h4>
                                <p>资深高企顾问团队支持，为企业后续申报高企提供微咨询服务</p>
                            </div>
                        </div>
                    </div>
                </div>
                <p class="text-center col-md-12 col-xs-12 pt-5 ">
                    <a class="btn-custom" href="http://pkt.zoosnet.net/LR/Chatpre.aspx?id=PKT58642380&lng=cn" rel='nofollow' target="_blank">
                        了解更多+
                    </a>
                </p>

            </div>
        </div>
    </section>
    <!-- 我们的承诺 -->
    <section class="figer-wrapper   pb-5 mt-5  ">
        <div class="container">
            <div class="row">
                <div class="col-md-12 col-xs-12">
                   <div class="title mb-5 container text-center title-hr">
                        <h3>我们承诺</h3>
                        <h4 class="text-1e6ce8 ">Commitment</h4>
                    </div>
                </div>
                <div class="col-md-12 col-xs-12">
                    <div class="clearfix  step-center pt-2 pt-xl-2">
                        <div class="in-choose-list wmcn">
                            <div class="item">
                                  <img :src="activeImg[26].img" >
                                <p class=" font-16 font-bold  mt-20">办到成功为止<br /> 不过退全款</p>
                            </div>
                            <div class="item">
                                 <img :src="activeImg[27].img" >
                                <p class=" font-16 font-bold  mt-20">资质正规<br />  有保障</p>
                            </div>
                            <div class="item">
                                 <img :src="activeImg[28].img" >
                                <p class="font-16 font-bold mt-20">服务真诚<br />  无套路</p>
                            </div>
                            <div class="item">
                                <img :src="activeImg[29].img" >
                                <p class="font-16 font-bold  mt-20">高效率 <br /> 工作宗旨</p>
                            </div>
                            <div class="item">
                                 <img :src="activeImg[30].img" >
                                <p class="font-16 font-bold  mt-20">一次合作 <br /> 终生服务</p>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>

    </section>
    <!-- 关于机巧-->
    <section class="figer-wrapper   pb-5 mt-5 bgf8f6f9">
        <div class="container">
            <div class="row">
                <div class="col-md-12 col-xs-12">
                    <div class="title mb-5 container text-center title-hr">
                        <h3>关于机巧</h3>
                        <h4 class="text-1e6ce8 ">About us</h4>
                    </div>
                </div>
                <div class="col-md-5 col-xs-12 col-md-offset-1 font-18 ">
                    <ul class="about-us-ul">
                        <li><p><span class="text-1e6ce8">16年</span>企业服务经验<span class="text-1e6ce8">15000+</span>客户鉴证</p></li>
                        <li><p>上百人<span class="text-1e6ce8">985</span>、常春藤顶尖服务团队</p></li>
                        <li><p>中国注册会计师，注册税务师，资深创业导师智囊团队</p></li>
                        <li><p>企业财务外脑管家团队，资深高企科小顾问团队</p></li>
                        <li><p>上海市代理记账副会长单位</p></li>
                        <li><p>上海市经信委严选的中小企业公共服务机构</p></li>
                        <li><p>上海市浦东新区财政买单项目连续<span class="text-1e6ce8">10年</span>中标单位</p></li>
                    </ul>
                </div>
                <div class="col-md-5 col-xs-12 font-18">
                    <ul class="about-us-ul">
                        <li><p>荣获2021年上海市入库科技型中小企业称号</p></li>
                        <li><p>入围2021年上海最具投资潜力<span class="text-1e6ce8">50</span>佳中小企业</p></li>
                        <li><p>中国民生银行上海分行战略合作伙伴</p></li>
                        <li><p>渤海银行战略合作伙伴</p></li>
                        <li><p>蚂蚁金服商业合作伙伴</p></li>
                        <li><p>上海市企业服务云优秀服务机构</p></li>
                        <li><p>天眼查严选企服合作服务商</p></li>
                    </ul>
                </div>
                <div class="col-md-12 col-xs-12 col-xs-12  ">
                     <img :src="activeImg[31].img" alt="关于机巧" style="width:100%" >
                </div>
                <p class="text-center col-md-12 col-xs-12 pt-5 ">
                    <a class="btn-custom" href="http://pkt.zoosnet.net/LR/Chatpre.aspx?id=PKT58642380&lng=cn" rel='nofollow' target="_blank">
                        了解更多+
                    </a>
                </p>
            </div>
        </div>

    </section>
  </div>
</template>
<script>
import $ from 'jquery'
import '../../../assets/css/circle.css'
import md5 from 'js-md5'
import axios from 'axios'
import url from '../../../modules/api.js'
import { Loading } from 'element-ui'
export default{
  name: 'Content',
  data () {
    return {
      company: '',
      telephone: '',
      activeImg: [
        { img: require('../../../assets/image/img-smskjxzxqy-bg.png') },
        { img: require('../../../assets/image/img-kjxzxqy-good-01.png') },
        { img: require('../../../assets/image/img-kjxzxqy-good-02.jpg') },
        { img: require('../../../assets/image/img-kjxzxqy-good-03.jpg') },
        { img: require('../../../assets/image/img-kjxzxqy-good-04.jpg') },
        { img: require('../../../assets/image/img-kjxzxqy-good-05.jpg') },
        { img: require('../../../assets/image/img-kjxzxqy-good-06.jpg') },
        { img: require('../../../assets/image/img-kjxzxqy-good-07.jpg') },
        { img: require('../../../assets/image/img-kjxzxqy-good-08.jpg') },
        { img: require('../../../assets/image/img-kjxzxqy-good-09.jpg') },
        { img: require('../../../assets/image/img-kjxzxqy-good-10.png') },
        { img: require('../../../assets/image/img-kjxzxqy-company-bg.png') },
        { img: require('../../../assets/image/img-sqsxclqd-01.png') },
        { img: require('../../../assets/image/img-sqsxclqd-02.png') },
        { img: require('../../../assets/image/img-sqsxclqd-03.png') },
        { img: require('../../../assets/image/img-sqsxclqd-04.png') },
        { img: require('../../../assets/image/img-sqsxclqd-05.png') },
        { img: require('../../../assets/image/img-sqsxclqd-06.png') },
        { img: require('../../../assets/image/img-sblcsj-01.png') },
        { img: require('../../../assets/image/img-sblcsj-02.png') },
        { img: require('../../../assets/image/img-sblcsj-03.png') },
        { img: require('../../../assets/image/img-sblcsj-04.png') },
        { img: require('../../../assets/image/img-sblcsj-05.png') },
        { img: require('../../../assets/image/img-sblcsj-06.png') },
        { img: require('../../../assets/image/img-sblcsj-07.png') },
        { img: require('../../../assets/image/img-rkkjxzxqy-lc.png') },
        { img: require('../../../assets/image/img-icon-wmcn-05.png') },
        { img: require('../../../assets/image/img-icon-wmcn-01.png') },
        { img: require('../../../assets/image/img-icon-wmcn-02.png') },
        { img: require('../../../assets/image/img-icon-wmcn-03.png') },
        { img: require('../../../assets/image/img-icon-wmcn-04.png') },
        { img: require('../../../assets/image/img-rkzxqy-gyqh-bg.png') },
        { img: require('../../../assets/image/img-rkzxqy-modeal-3.png') },
        { img: require('../../../assets/image/img-rkzxqy-modeal-4.png') }
      ]
    }
  },
  mounted () {
  },
  methods: {
    submitForm: function (event) {
      let self = this

      var company = self.company
      var telephone = encodeURIComponent(self.telephone)
      if (company.length <= 0) {
        this.$alert("<div style='font-size:18px;text-align:center'>请输入正确的公司名！</div>", {
          dangerouslyUseHTMLString: true,
          showConfirmButton: false
        })
        return
      }
      if (telephone.length <= 0) {
        this.$alert("<div style='font-size:18px;text-align:center'>请输入您的电话！</div>", {
          dangerouslyUseHTMLString: true,
          showConfirmButton: false
        })
        return
      }
      if (telephone.length < 8) {
        this.$alert("<div style='font-size:18px;text-align:center'>请输入正确的电话或者手机号码！</div>", {
          dangerouslyUseHTMLString: true,
          showConfirmButton: false
        })
        return
      }
      var date = new Date()
      var Y = date.getFullYear()
      var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1)
      var D = date.getDate() + ' '
      var Time = ('COMMON_' + Y + '_' + M + '_' + D).replace(/\s+/g, '')
      var hashTime = md5(Time).toUpperCase()
      var postData = {
        'key': hashTime,
        'request_category': company,
        'request_name': '未提供',
        'request_phone': telephone,
        'request_data': '科技型中小企业申请表单',
        'flag': 'F'
      }
      let loadingInstance = Loading.service()
      axios.post(url.PostMarktingForm, postData).then(res => {
        this.$alert("<div style='font-size:14px;text-align:center'>亲，您已申请成功~您想知道的科技型中小企业申请详情,我们会尽快和您回电详谈！</div>", {
          dangerouslyUseHTMLString: true,
          showConfirmButton: false
        })
        loadingInstance.close()
        console.log(res.data, 'res.data')
      }).catch(err => {
        console.log(err, 'error')
        this.$alert(err)
        loadingInstance.close()
        // error callback
      })
    }
  }
}
</script>
<style scoped>
.btn-custom {
    padding: 10px 30px;
    background-image: linear-gradient(to right, #3ba7ff, #044fff);
    border-radius: 5px;
    color: #fff;
    text-decoration: none;
    margin: 0 auto;
    width:180px;
    text-align: center
}
.zcdz-main.kjxzxqy .item {
    margin-bottom: 20px;
    background: #fff;
}
.zcdz-main.kjxzxqy .item h5 {
    font-size: 16px;
    color: #1e6ce8;
    line-height: 30px;
    font-weight: bold;
}
.zcdz-main.kjxzxqy .item p {
    margin-bottom: 5px;
    font-size: 14px;
}
.zcdz-main.kjxzxqy .item a {
    color: #000;
    font-size: 14px;
    position: absolute;
    bottom: 0px;
    display: block;
    /* left: 10px; */
}
.zcdz-main.kjxzxqy .item .left img{
    width: 100%;
    height: 100%;
}
.zcdz-main.kjxzxqy .li .item  .right {
   height:150px
}

.zcdz-main.kjxzxqy .li:nth-child(9) .item  .right,.zcdz-main.kjxzxqy .li:nth-child(10) .item  .right {
    height:245px
}
.zcdz-main.kjxzxqy .li:nth-child(7) .item .right,.zcdz-main.kjxzxqy .li:nth-child(8) .item  .right {
    height:200px
}
.in-zc-from-mb {
    margin:20px auto 60px
}
.in-zc-from-content {
    background:#0e4f76;
    padding:20px;
    border-radius:15px
}
.in-zc-from-content .input-group .form-control{
    width: 100%;
}
.in-zc-from-content .input-group .form-control:last-child,.in-zc-from-content .input-group-addon:last-child,.in-zc-from-content .input-group-btn:first-child>.btn-group:not(:first-child)>.btn,.in-zc-from-content .input-group-btn:first-child>.btn:not(:first-child),.in-zc-from-content .input-group-btn:last-child>.btn,.in-zc-from-content .input-group-btn:last-child>.btn-group>.btn,.in-zc-from-content .input-group-btn:last-child>.dropdown-toggle {
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
}
.in-zc-from-content .input-group .form-control:first-child,.in-zc-from-content  .input-group-addon:first-child,.in-zc-from-content  .input-group-btn:first-child>.btn,.in-zc-from-content  .input-group-btn:first-child>.btn-group>.btn,.in-zc-from-content  .input-group-btn:first-child>.dropdown-toggle,.in-zc-from-content  .input-group-btn:last-child>.btn-group:not(:last-child)>.btn,.in-zc-from-content  .input-group-btn:last-child>.btn:not(:last-child):not(.dropdown-toggle) {
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
}
.in-zc-from .in-zc-from-content .btn {
    border: 1px solid #1e6ce8;
    background: #1e6ce8;
    line-height: 2;
}
.in-nxqykukjzxqy-main{
    background: url(../../../assets/image/img-nxrkkjxzxqy-bg.png) no-repeat;
    color: #fff;
    background-size:cover
}
.in-nxqykukjzxqy-main .list {
    margin:30px auto
}
.in-nxqykukjzxqy-main .list .item {
    border-bottom: 1px dashed #fff;
    font-size:16px;
    line-height:44px;
    display:flex
}
.in-nxqykukjzxqy-main .list .item .num {
    color:#1e6ce8;
    font-size:24px;
    font-weight:600;
    position:relative;
    padding-right:5px;
    flex:1
}
.in-nxqykukjzxqy-main .list .item .right {
    flex:12
}
.in-choose .in-choose-step {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    margin-right: -15px;
    margin-left: -15px;
}
.in-choose  .step-center .list{
     -ms-flex-preferred-size: 0;
    flex-basis: 0;
    -webkit-box-flex: 1;
    -ms-flex-positive: 1;
    flex-grow: 1;
    max-width: 100%;
}
.in-choose  .step-center .item{
  position: relative;
  color:#333;
  text-align:center;
  margin:80px 0;
}

.in-choose  .step-center .item i{
  font-size: 46px;
  color:  #1e6ce8;
  padding: 20px;
  background: #ffffff;
  border-radius: 50%;

}
.in-choose  .step-center .item span {
  position: absolute;
  font-size: 36px;
  background-size: contain;
  background-position: right center;
  right: -20px;
  top: 15px;
  z-index: 2;
  color: #1e6ce8;
}
.in-choose  .step-center .item p{
 margin:25px 0;
 font-size:14px
}
.in-choose  .step-center .list:hover i,.in-choose  .step-center .list:hover p{
  color:  #1e6ce8;

}

.in-choose   .more{
  display: block;
  font-size: 16px;
  text-align:center;
  margin-bottom:80px;
  color:#fff
}
.in-choose-list {
    display:flex;
    margin:0px auto 50px
}
.in-choose-list .item{
    flex:1;
    position:relative;
}
.in-choose-list.wmcn .item{
    width: calc((100% - 200px) / 5);
    min-width: calc((100% - 200px) / 5);
    max-width: calc((100% - 200px) / 5);
    text-align:center;
    box-shadow: 0 2px 4px 0 rgb(158 158 158 / 40%);
    margin: 0 20px 20px 20px;
    padding: 52px 10px 40px;
    border-radius:6px
}
.in-choose-list.wmcn .item:nth-child(5n + 5){
     margin-right: 0;
}
.in-choose-list .item .title {
    position:absolute;
    bottom:20px;
    left:50%;
    margin-left:-45px

}
.in-choose-list .item:nth-child(5) .title {
    margin-left:-50px

}
.img-responsive{
    margin: 0 auto;
}
.in-fwnr-main {
    display: flex;
   justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    margin:40px 0
}
.in-fwnr-main .item{
    flex: 1;
    height: 140px;
    text-align: center;
    margin: 0 20px 20px 0;
    padding: 32px 10px 20px;
    box-sizing: border-box;
    width: calc((100% - 60px) / 3);
    min-width: calc((100% - 60px) / 3);
    max-width: calc((100% - 60px) / 3);
    background:#ffffff;
    border-radius:4px
}
.in-fwnr-main-01 .item:nth-child(3n + 3){
     margin-right: 0;
}

.in-fwnr-main .item .left {
    width: 72px;
    height: 72px;
    background: #e5ecff;
    border-radius: 5px;
    float: left;
}
.in-fwnr-main .item .left i{
   font-size:48px;
   color:#1e6ce8
}
.in-fwnr-main .item h4 {
   font-size:16px;
   margin-top: 5px;
   margin-bottom: 5px;
}
.in-fwnr-main .item .right {
   text-align:left;
   margin-left:78px;
   font-size: 14px;
}
.modal-dialog-kjxzxqy .modal-header{
    background: #fff;
    color: #fff;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    text-align: center;
    border-bottom:0;
    padding:2px 5px
}
.about-us-ul{
    list-style:outside;
}
</style>



// WEBPACK FOOTER //
// src/pages/technology/components/Content.vue